import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPut } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_RATINGS_PATH_KEY } from '@/swagger/constants/contents-rating-keys';
import { KEY_PUT_CONTENTS_RATING, API_PUT_CONTENTS_RATING } from '../constants';
import { MOCK_RESPONSE_PUT_CONTENTS_RATING } from '../mocks';

export type RequestPutContentsRating = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_RATINGS_PATH_KEY
>['request']['body'];

export type ResponsePutContentsRating = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_USER_CONTENT_RATINGS_PATH_KEY
>['response']['body'];

export type CallParamsPutContentsRating = Omit<RequestPutContentsRating, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePutContentsRating = ResponsePutContentsRating;

type CallErrorPutContentsRating = {
  message: string;
  code: number;
  type: string;
  title: string;
  status: number;
};

type CallSelectorsPutContentsRating = unknown;

export const putContentsRatingCall = createGeneralCall<
  CallParamsPutContentsRating,
  CallResponsePutContentsRating,
  CallErrorPutContentsRating,
  CallSelectorsPutContentsRating
>({
  id: KEY_PUT_CONTENTS_RATING,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_PUT_CONTENTS_RATING(org as unknown as string);
  },
  method: 'put',
  paramsSelector:
    ({ payload }) =>
    () => {
      return {
        ...payload,
      };
    },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_PUT_CONTENTS_RATING : undefined,
});
